import { InfoCircleOutlined } from '@ant-design/icons';
import { useAllowedImgExtensions } from '@features/offers/hooks/useAllowedImgExtensions';
import { Controller, TextAreaController } from '@organisms';
import { Col, Flex, Row, Typography } from 'antd';
import { FC } from 'react';

import { UploadImage } from 'src/features/Funnel/Components/UploadImage';

interface FormBasicDataProps {
  control: any;
}

export const FormBasicData: FC<FormBasicDataProps> = ({
  control,
}: FormBasicDataProps) => {
  const { allowedImgExtensions } = useAllowedImgExtensions([
    'jpg',
    'jpeg',
    'png',
    'gif',
  ]);
  return (
    <Flex vertical style={{ marginBlock: '24px' }}>
      <Col style={{ width: '100%' }}>
        <Controller
          control={control}
          showCount={true}
          name={`offerName`}
          defaultValue={''}
          placeholder='Digite o nome da oferta'
          autoComplete='off'
          label='Nome da Oferta'
          maxLength={80}
          required
        />
      </Col>
      <Col style={{ width: '100%' }}>
        <TextAreaController
          control={control}
          name={`offerDescription`}
          defaultValue={''}
          placeholder='Digite seu texto aqui.'
          label='Descrição'
          isMaxLength={false}
          row={4}
          required
        />
      </Col>
      <Row
        style={{
          display: 'flex',
          paddingBlockStart: '24px',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Col style={{ flex: 1, paddingInlineEnd: '12px' }}>
          <UploadImage
            style={{ width: '100%' }}
            tooltip={{
              title: () => (
                <Typography.Text>
                  Banner Web - 602 x 131 pixels (
                  {allowedImgExtensions.allowedExtensionsText})
                </Typography.Text>
              ),
              icon: <InfoCircleOutlined />,
            }}
            control={control}
            name={`bannerWeb`}
            label='Banner Web'
            required={false}
            includeResourceBaseUrl
            allowedExtensions={allowedImgExtensions.allowedExtensions}
          />
        </Col>
        <Col
          style={{
            flex: 1,
            paddingInlineStart: '12px',
          }}
        >
          <UploadImage
            style={{ width: '100%' }}
            tooltip={{
              title: () => (
                <Typography.Text>
                  Banner Responsivo - 351 × 203 pixels (
                  {allowedImgExtensions.allowedExtensionsText})
                </Typography.Text>
              ),
              icon: <InfoCircleOutlined />,
            }}
            control={control}
            name={`bannerMobile`}
            label='Banner Responsivo'
            required={false}
            includeResourceBaseUrl
            allowedExtensions={allowedImgExtensions.allowedExtensions}
          />
        </Col>
      </Row>
      <Row
        style={{
          display: 'flex',
          paddingBlockStart: '24px',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Col style={{ flex: 1, paddingInlineEnd: '12px' }}>
          <UploadImage
            style={{ width: '100%' }}
            tooltip={{
              title: () => (
                <Typography.Text>
                  Banner Lateral - 225 x 754 pixels (
                  {allowedImgExtensions.allowedExtensionsText})
                </Typography.Text>
              ),
              icon: <InfoCircleOutlined />,
            }}
            control={control}
            name={`bannerSideWeb`}
            label='Banner Lateral'
            required={false}
            includeResourceBaseUrl
            allowedExtensions={allowedImgExtensions.allowedExtensions}
          />
        </Col>
        <Col style={{ flex: 1, paddingInlineStart: '12px' }}>
          <UploadImage
            style={{ width: '100%' }}
            tooltip={{
              title: () => (
                <Typography.Text>
                  Logotipo da Oferta - 40x40 pixels (
                  {allowedImgExtensions.allowedExtensionsText})
                </Typography.Text>
              ),
              icon: <InfoCircleOutlined />,
            }}
            control={control}
            name={`logo`}
            label='Logotipo da Oferta'
            required={false}
            includeResourceBaseUrl
            allowedExtensions={allowedImgExtensions.allowedExtensions}
          />
        </Col>
      </Row>
    </Flex>
  );
};
